import { CONTENT_TYPES } from 'constants/games/contentTypes'
import { MultipleAchievementCSS } from './MultipleAchievementCSS.styled'
import { useEffect, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { useYoloToast } from 'lib/yoloToasts/useYoloToast'
import { icons } from 'common'
import ms from 'ms.macro'

export const MultipleAchievement = ({ msg, noToast }) => {
  const paragraph = useMemo(
    () => (
      <>
        You've completed these goals:
        <ul>
          {msg.map((item, idx) => (
            <li key={`ach${idx}`}>
              <b>{item.achievementName}</b>
            </li>
          ))}
        </ul>
        <Link to={`/game/${CONTENT_TYPES.ACHIEVEMENT}`} className='header_link' type='button'>
          Keep going to earn more rewards!
        </Link>
      </>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  //Toast Logic
  const { yToast } = useYoloToast()
  useEffect(() => {
    if (noToast) return
    const announcementToastObj = {
      id: 'achievementToast',
      autoClose: ms`15s`,
      props: {
        icon: icons.ach_check_checked_3_dark,
        message: {
          title: <strong>ACHIEVEMENT GOAL REACHED</strong>,
          subtitle: paragraph,
        },
      },
    }
    yToast(announcementToastObj)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  //Toast Logic

  return (
    <MultipleAchievementCSS>
      <div className='message user achivement_announcement_private'>
        <div className='user_avatar'>
          <div className='avatar_image'></div>
        </div>
        <div className='message_content'>
          <span className='user_name'>ACHIEVEMENT GOAL REACHED</span>
          <span className='message_copy'>{paragraph}</span>
        </div>
      </div>
    </MultipleAchievementCSS>
  )
}
